import Collection from './Collection';

export default class PagedCollection<T extends ModelConstructor> extends Collection<T> {
	protected _filters: { [x: string]: { value: unknown; required: boolean; } } & {
		itemsPerPage?: { value: unknown; required: boolean; };
	} = {
		page: { value: 1, required: true },
		itemsPerPage: { value: 10, required: true },
	};
}
